{
  "DATA_ASSISTANT": {
    "TITLE": "Podatkovni asistent",
    "NEW_CONVERSATION": "+ Novo",
    "LOADING": "Učitavanje...",
    "LOADING_MESSAGES": "Učitavanje poruka...",
    "THINKING": "Razmišljam...",
    "UNTITLED": "Razgovor bez naziva",
    "NO_CONVERSATIONS": "Još nema razgovora. Kliknite \"+ Novo\" za početak.",
    "EMPTY_STATE": "Odaberite razgovor ili kreirajte novi da biste započeli.",
    "SEND": "Pošalji",
    "PLACEHOLDER": "Što mogu saznati za vas?",
    "SHOW_SQL": "Prikaži SQL",
    "NO_ROWS": "Nema vraćenih redaka.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Izbriši razgovor",
    "DELETE_CONFIRM_DESCRIPTION": "Jeste li sigurni da želite izbrisati ovaj razgovor? Ova radnja se ne može poništiti.",
    "DELETE_CONFIRM_YES": "Izbriši",
    "CHAT": "Chat",
    "REPORTS": "Izvještaji",
    "SAVE_TO_REPORT": "Spremi u izvještaj",
    "NEW_REPORT": "Novi izvještaj",
    "REPORT_NAME": "Naziv izvještaja",
    "NO_REPORTS": "Još nema spremljenih izvještaja",
    "REPORTS_EMPTY_STATE": "Odaberite izvještaj ili kreirajte novi.",
    "REPORT_SAVED": "Spremljeno u izvještaj",
    "DELETE_REPORT_CONFIRM": "Izbriši izvještaj",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Jeste li sigurni da želite izbrisati ovaj izvještaj? Sve spremljene stavke bit će uklonjene.",
    "DELETE_ITEM_CONFIRM": "Ukloni stavku",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Jeste li sigurni da želite ukloniti ovu stavku iz izvještaja?",
    "EXPORT_CSV": "Izvezi CSV",
    "REFRESH": "Osvježi",
    "QUERY_RUNNING": "Izvršavanje upita...",
    "QUERY_FAILED": "Upit neuspješan",
    "AUTO_REFRESH": "Automatsko osvježavanje",
    "AUTO_REFRESH_NONE": "Ručno",
    "AUTO_REFRESH_30S": "30 sekundi",
    "AUTO_REFRESH_1M": "1 minuta",
    "AUTO_REFRESH_5M": "5 minuta",
    "AUTO_REFRESH_10M": "10 minuta",
    "EDIT_MESSAGE": "Uredi poruku",
    "RENAME_REPORT": "Preimenuj izvještaj",
    "RENAME_ITEM": "Preimenuj stavku",
    "MOVE_UP": "Pomakni gore",
    "MOVE_DOWN": "Pomakni dolje",
    "COLLABORATORS": {
      "BUTTON": "Suradnici",
      "TITLE": "Suradnici izvješća",
      "DESCRIPTION": "Odaberite koji agenti i timovi mogu vidjeti ovo izvješće.",
      "AGENTS": "Agenti",
      "TEAMS": "Timovi",
      "SELECT_AGENTS": "Odaberi agente",
      "SELECT_TEAMS": "Odaberi timove",
      "SAVE": "Spremi",
      "SAVED": "Suradnici su ažurirani",
      "SAVE_FAILED": "Ažuriranje suradnika nije uspjelo"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Izvještaji"
}
